<div class="bg-white p-6 rounded-md shadow-sm">
  <div class="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">
    <div>
      <h2 class="text-xl font-bold text-gray-800">{{ 'backOffice.settings.posDevicesPage.title' | translate }}</h2>
      <p class="text-gray-600 mt-1">{{ 'backOffice.settings.posDevicesPage.description' | translate }}</p>
    </div>
    <div class="flex items-center gap-4">
      <select [(ngModel)]="selectedStoreId" class="border-gray-300 rounded-md py-2 px-3 text-sm">
        <option value="all">ร้านค้าทั้งหมด</option>
        @for(store of stores(); track store.id) {
          <option [value]="store.id">{{ store.name }}</option>
        }
      </select>
      <button (click)="openAddModal()" class="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700 transition-colors flex items-center gap-2">
        <i class="fa-solid fa-plus"></i>
        <span>{{ 'backOffice.settings.posDevicesPage.addNew' | translate }}</span>
      </button>
    </div>
  </div>

  @if(isLoading()) {
    <div class="text-center py-10 text-gray-500"><i class="fa-solid fa-spinner animate-spin text-2xl"></i></div>
  } @else if(error()) {
    <div class="bg-red-100 text-red-700 p-4 rounded-md">{{ error() }}</div>
  } @else {
    <div class="overflow-x-auto">
      <table class="min-w-full bg-white">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">{{ 'backOffice.settings.posDevicesPage.table.name' | translate }}</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">{{ 'backOffice.settings.posDevicesPage.table.store' | translate }}</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">{{ 'backOffice.settings.posDevicesPage.table.status' | translate }}</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">{{ 'backOffice.settings.posDevicesPage.table.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          @for(device of filteredDevices(); track device.id) {
            <tr>
              <td class="px-6 py-4 font-medium text-gray-900">{{ device.name }}</td>
              <td class="px-6 py-4 text-gray-700">{{ device.storeName }}</td>
              <td class="px-6 py-4">
                @if (device.status === 'active') {
                  <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">เปิดใช้งานแล้ว</span>
                } @else {
                  <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">ยังไม่เปิดใช้งาน</span>
                }
              </td>
              <td class="px-6 py-4 text-right text-sm space-x-4">
                <button (click)="openEditModal(device)" class="text-emerald-600 hover:text-emerald-900">{{ 'backOffice.productManagement.edit' | translate }}</button>
                <button (click)="deleteDevice(device)" class="text-red-600 hover:text-red-900">{{ 'backOffice.productManagement.delete' | translate }}</button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="4" class="text-center py-10 text-gray-500">No POS devices found.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

<app-pos-device-form-modal
  [isOpen]="isModalOpen()"
  [device]="editingDevice()"
  [stores]="stores()"
  (closeModal)="handleCloseModal()"
  (saveDevice)="handleSaveDevice($event)">
</app-pos-device-form-modal>